import React from "react";
import GridHeader from "./grid-header";
import GridNav from "./grid-nav";
import GridTopFilters from "./grid-top-filters";
import QuickFilters from "./quick-filters";
import { withBrowser } from "../../layout/BrowserContext";
import { replaceFilterOptions } from "../../../helpers/grid-epic-filter-options";
import { Cookies, withCookies } from "react-cookie";
import { compose } from "redux";
import { connect } from "react-redux";
import { withUserData } from "../hoc/with-user-data";
import { MoleculeIconList } from "../molecules/molecule-icon-list";
import PropTypes from "prop-types";
import {
  browserPropType,
  rentMyStyleQuizContentPropType,
  occasionsBarPropType,
  gridViewPropType,
  membershipStatePropType,
} from "components/propTypes";
import { Flags, withFeatureFlags } from "../hoc/with-feature-flags";
import { RENTAL_INTENT, superbarFilterKeys } from "rtr-constants";
import { isStorefrontNext } from "../../../helpers/environment-helpers";
import { removeFiltersForNextGridType } from "../../../helpers/disco-filter-helpers";

const TOP_OF_PAGE = 0;
// TODO: Replace grid.jsx nav code in SF ruby with this and make sure it still works
// phase 2 is to add it to next and provide the data it expects

export class GridTop extends React.Component {
  static propTypes = {
    // maybe instead of drilling these callback funcs, we should have the listeners `connect` for some state and have the emitters change that state via an action?
    onRemoveFilter: PropTypes.func,
    onRemoveMultipleFilters: PropTypes.func,
    submitFilters: PropTypes.func,
    closeProductDrawer: PropTypes.func,
    onChangePage: PropTypes.func,
    // drilled, everything here should be a helper or a connect in the relevant component
    isUnlimitedRentableGrid: PropTypes.bool,
    isDeadEndTextSearch: PropTypes.bool,
    isSearchResultGrid: PropTypes.bool,
    currentIntent: PropTypes.string,
    // default only?
    showQuickFilters: PropTypes.bool,
    hideGridHeader: PropTypes.bool,
    // regular usage, mostly connect-ed
    accessoryOnly: PropTypes.bool,
    browser: browserPropType,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    dateOptions: PropTypes.shape({
      blackoutDays: PropTypes.arrayOf(PropTypes.string).isRequired,
      dateEnd: PropTypes.string.isRequired,
      dateStart: PropTypes.string.isRequired,
    }).isRequired,
    deliveryCutoffs: PropTypes.arrayOf(PropTypes.object),
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    filterOptions: PropTypes.object,
    filters: PropTypes.shape({
      canonicalSizes: PropTypes.arrayOf(PropTypes.string),
      primarySize: PropTypes.string,
      zipCode: PropTypes.string,
      date: PropTypes.string,
      duration: PropTypes.string,
      depot_id: PropTypes.string,
      zip_code: PropTypes.string,
      searchText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
    gridType: PropTypes.string,
    gridView: gridViewPropType,
    loading: PropTypes.bool,
    membershipState: membershipStatePropType,
    nextPage: PropTypes.bool,
    occasionsBarContent: occasionsBarPropType,
    page: PropTypes.number,
    paidMarketingBanner: PropTypes.shape({
      imgUrl: PropTypes.string,
    }),
    path: PropTypes.string,
    previousPage: PropTypes.bool,
    quizContent: PropTypes.shape({
      quizContent: rentMyStyleQuizContentPropType,
    }),
    resultsCount: PropTypes.number,
    searchText: PropTypes.oneOf([PropTypes.array, PropTypes.string]),
    shortlists: PropTypes.array,
    subject: PropTypes.shape({
      displayName: PropTypes.string,
      id: PropTypes.string,
      parent: PropTypes.object,
      type: PropTypes.string,
    }),
    title: PropTypes.string,
    totalPages: PropTypes.number,
    userData: PropTypes.shape({
      isUnlimitedLens: PropTypes.bool,
      isRTRUpdateLens: PropTypes.bool,
      userProfile: PropTypes.object,
    }).isRequired,
    workingSort: PropTypes.string,
  };

  static defaultProps = {
    showQuickFilters: true,
    hideGridHeader: false,
  };

  state = {
    isFirstRender: true,
  };

  gridNavTopperRef = React.createRef();

  componentDidMount() {
    // MH Explanation 2-24-20: componentDidMount runs right after the first render
    // this.state.isFirstRender prevents certain DOM elements from rendering server-side
    this.setState({ isFirstRender: false });
  }

  isPurchaseGrid() {
    return this.props.gridView.isBuyNow || this.props.gridView.isClearance;
  }

  productsLoading() {
    return this.state.isFirstRender || (this.props?.loading ?? false);
  }

  hideGridHeaderCount() {
    // MH Explanation 2-25-20: If the products haven't loaded yet, don't try to render a count of the products
    return this.productsLoading() || this.props.isUnlimitedRentableGrid || this.props.userData?.isRTRUpdateLens;
  }

  getTopFiltersPosition() {
    if (!this.gridNavTopperRef?.current) return TOP_OF_PAGE;
    return this.gridNavTopperRef.current.getBoundingClientRect().top;
  }

  /**
   * On filter change, only scroll to top of grid if the filters are not currently in the viewport.
   */
  shouldScrollToTopFiltersOnSubmit() {
    const topFiltersPosition = this.getTopFiltersPosition();

    return topFiltersPosition < 0 || topFiltersPosition > window?.innerHeight;
  }

  scrollToTopFilters = () => {
    if (!this.shouldScrollToTopFiltersOnSubmit()) {
      return;
    }

    const scrollDistance = this.getTopFiltersPosition() + window.scrollY - 20;
    window.scrollTo({ top: scrollDistance, behavior: "smooth" });
  };

  renderQuickFilters() {
    if (!this.props.showQuickFilters) {
      return;
    }

    //We are not showing quickFilters on mobile grids
    const { browser: { isMobileViewport } = {} } = this.props;
    if (isMobileViewport) {
      return;
    }

    const filters = this.props?.filters ? { ...this.props.filters } : {};

    //Remove any filters applied from Superbar from Quick Filters
    superbarFilterKeys.forEach(key => {
      delete filters[key];
    });

    const shortlistsForQuickFilters = {
      displayName: "Shortlists",
      values: (this.props.shortlists || []).map(shortlist => {
        return {
          displayName: shortlist.name,
          id: shortlist.id,
        };
      }),
    };
    const filterOptions = {
      ...this.props.filterOptions,
      productCollections: shortlistsForQuickFilters,
    };

    return (
      <QuickFilters
        key="quick-filters"
        accessoryOnly={this.props.accessoryOnly}
        filterOptions={filterOptions}
        filters={filters}
        removeFilter={this.props.onRemoveFilter}
        removeMultipleFilters={this.props.onRemoveMultipleFilters}
        isDeadEndTextSearch={this.props.isDeadEndTextSearch}
      />
    );
  }

  renderGridTopFilters() {
    return (
      <GridTopFilters
        browser={this.props.browser}
        currentIntent={this.props.currentIntent}
        dateOptions={this.props.dateOptions}
        deliveryCutoffs={this.props.deliveryCutoffs}
        displayedModal={this.props.displayedModal}
        gridType={this.props.gridType}
        gridView={this.props.gridView}
        key="grid-top-filters"
        membershipState={this.props.membershipState}
        message={this.props.quizContent?.quizContent?.panels?.date_select?.message}
        messageTwo={this.props.quizContent?.quizContent?.panels?.date_select?.messageTwo}
        path={this.props.path}
        resultsCount={this.props.resultsCount}
        scrollToTopFilters={this.scrollToTopFilters}
        sort={this.props.workingSort}
        submitFilters={this.props.submitFilters}
        userData={this.props.userData}>
        {this.renderQuickFilters()}
      </GridTopFilters>
    );
  }

  renderGridNav() {
    return (
      <GridNav
        key="grid-nav"
        gridView={this.props.gridView}
        nextPage={this.props.nextPage}
        page={this.props.page}
        path={this.props.path}
        previousPage={this.props.previousPage}
        resultsCount={this.props.resultsCount}
        totalPages={this.props.totalPages}
        closeProductDrawer={this.props.closeProductDrawer}
        onChangePage={this.props.onChangePage}
      />
    );
  }
  renderOccasionsBar() {
    const { occasionsBarContent } = this.props;
    if (!this.shouldDisplayOccasionsBar(occasionsBarContent)) return;

    return (
      <MoleculeIconList
        listTitle={occasionsBarContent.title}
        listItems={occasionsBarContent.listItems}
        isTiled={false}
        backgroundColor={occasionsBarContent.background}
        hedAttributes={occasionsBarContent.hedAttributes}
        inGrid={true}
        textClass={occasionsBarContent.textClass}
      />
    );
  }

  shouldDisplayOccasionsBar(occasionsBarContent) {
    const { currentIntent, path, isSearchResultGrid, browser: { isMobileViewport } = {} } = this.props;

    if (
      occasionsBarContent &&
      currentIntent &&
      currentIntent !== RENTAL_INTENT.RESERVE &&
      !isMobileViewport &&
      (occasionsBarContent?.paths?.some(occasionsPath => occasionsPath === path) || isSearchResultGrid)
    )
      return true;
  }

  render() {
    const {
      hideGridHeader,
      paidMarketingBanner,
      resultsCount,
      searchText,
      subject,
      title,
      cookies,
      browser: { isMobileViewport },
    } = this.props;
    const hasPaidMarketingBanner = !!paidMarketingBanner;
    const showGridHeader = !hideGridHeader && !hasPaidMarketingBanner;

    let header;
    let gridOverheadBanner;

    const deviceId = cookies.get("RTR_ID");

    if (showGridHeader) {
      header = (
        <GridHeader
          key="grid-header"
          extraClass="hide-sort-form superbar"
          deviceId={deviceId}
          displayedModal={this.props.displayedModal}
          searchText={searchText}
          hideCount={this.hideGridHeaderCount()}
          isSearchResultGrid={this.props.isSearchResultGrid}
          isMobileViewport={isMobileViewport}
          resultsCount={resultsCount}
          shortlistName={this.state.shortlistName}
          subject={subject}
          title={title}
          userData={this.props.userData}
        />
      );
    }

    // Note from MH: the wrapper divs around each section are necessary to keep
    // react from getting confused and rendering components inside siblings.
    // For more information: https://reactjs.org/docs/reconciliation.html
    return (
      <div
        data-test-id="grid-content-topper"
        className="grid-content-topper"
        key="grid-content-topper"
        ref={this.gridNavTopperRef}>
        {this.renderOccasionsBar()}
        <div className="header-wrapper" key="header-wrapper">
          {header}
        </div>
        <div className="grid-overhead-banner-wrapper" key="grid-overhead-banner-wrapper">
          {gridOverheadBanner}
        </div>
        <div className="nav-components" key="nav-components">
          {this.renderGridTopFilters()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (
  {
    accessoryOnly,
    filters,
    filterOptions,
    path,
    occasionsBarContent,
    loading,
    dateOptions,
    deliveryCutoffs,
    displayedModal,
    gridMetaData,
    gridType,
    gridView,
    membershipState,
    nextGridType,
    quizContent,
    workingSort,
    nextPage,
    page,
    previousPage,
    totalPages,
    paidMarketingBanner,
    shortlists,
    subject,
    title,
    workingFilters,
  },
  ownProps
) => ({
  accessoryOnly,
  filters: isStorefrontNext() ? removeFiltersForNextGridType(nextGridType, workingFilters) : filters,
  filterOptions:
    ownProps.filterOptions || replaceFilterOptions(filterOptions, accessoryOnly, path, ownProps.featureFlags),
  path,
  dateOptions: isStorefrontNext() ? ownProps.dateOptions : dateOptions,
  occasionsBarContent,
  loading,
  deliveryCutoffs,
  displayedModal,
  gridType,
  gridView,
  isSearchResultGrid: !!workingFilters?.searchText,
  membershipState,
  quizContent,
  workingSort,
  nextPage,
  page,
  previousPage,
  totalPages,
  paidMarketingBanner,
  searchText: Array.isArray(workingFilters?.searchText) ? workingFilters?.searchText[0] : workingFilters?.searchText,
  shortlists,
  subject,
  title: title || gridMetaData?.title || ownProps.title,
});

export default compose(
  // must go before connect as mapStateToProps depends on featureFlags
  withFeatureFlags(
    Flags.ENABLE_EPIC_OCCASIONS_FACET_INJECTION,
    Flags.ENABLE_EPIC_STYLE_FACET_INJECTION,
    Flags.ENABLE_EPIC_MATERNITY_FACET_INJECTION,
    Flags.ENABLE_EPIC_CATEGORIES_FACET_INJECTION,
    Flags.ENABLE_EPIC_COLOR_FACET_INJECTION,
    Flags.ENABLE_EPIC_PRINT_FACET_INJECTION,
    Flags.ENABLE_EPIC_EMBELLISHMENT_FACET_INJECTION,
    Flags.ENABLE_EPIC_WEATHER_FACET_INJECTION,
    Flags.ENABLE_EPIC_FORMALITY_FACET_INJECTION,
    Flags.ENABLE_EPIC_SLEEVE_FACET_INJECTION,
    Flags.ENABLE_EPIC_LENGTH_FACET_INJECTION,
    Flags.ENABLE_EPIC_NECKLINE_FACET_INJECTION
  ),
  connect(mapStateToProps, null),
  withBrowser(),
  withCookies,
  withUserData
)(GridTop);
